import { Box, keyframes, styled } from '@mui/material';
import { IconSize } from './LoadingIcon.types';

const wave = keyframes({
  '0%, 60%, 100%': {
    transform: 'scale(1)'
  },
  '30%': {
    transform: 'scale(1.3)'
  }
});

export const LoadingIconContent = styled(Box, {
  shouldForwardProp: (propName) => propName != 'size'
})<{ size: IconSize }>(({ theme, size }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  svg: {
    color: theme.vars.palette.grey[400],
    height: '20px',
    width: '20px',
    animation: `${wave} 1.2s infinite ease-in-out`,
    '&:nth-child(2)': {
      animationDelay: '0.2s'
    },
    '&:nth-child(3)': {
      animationDelay: '0.4s'
    },
    ...(size == 'SMALL' && {
      height: '14px',
      width: '14px'
    }),
    ...(size == 'LARGE' && {
      height: '30px',
      width: '30px'
    })
  }
}));
